<template>
	<div v-if="formData.deleted_at === null" class="container">
		<v-card :header="showTitle ? formData.title : ''">
			<inline-form :item="formData"></inline-form>
		</v-card>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {FormComponentInterface} from "../../Interfaces/Components/FormComponentInterface";
import VCard from "../../../../Components/VCard.vue";
import InlineForm from "../../../../Components/InlineForm.vue";

export default defineComponent({
	name: "FormComponent",
	components: {InlineForm, VCard},
	props: {
		formData: {
			type: Object as PropType<FormComponentInterface>,
			default: [],
			required: true
		},
		showTitle: {
			type: Boolean,
			default: true,
			required: false
		}
	},
});
</script>

<style scoped>

</style>
